import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=043dec1a&scoped=true&"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=043dec1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043dec1a",
  null
  
)

export default component.exports